import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';

interface IProps {
  children: React.ElementType | ReactNode;
  isSelected: boolean;
  classes?: string;
}

const MobileTabContainer: FC<IProps> = ({ children, isSelected, classes }): JSX.Element => {
  return <div className={classnames(classes, { 'active-tab': isSelected })}>{children}</div>;
};

export default MobileTabContainer;
